import React, { useState } from "react";

function Projects() {
  const [showModal, setShowModal] = useState(false);

  const projectList = [
    {
      title: "MyNotes Library",
      description: "A Firebase-powered web app where students can save, manage, and share notes.",
      liveLink: "https://mynotes-library.vercel.app/",
      codeLink: "https://github.com/kdgohil01/mynotes-library",
    },
    {
      title: "Quotes App",
      description: "A mobile-friendly app that shows a new motivational quote every day.",
      liveLink: "#",
      codeLink: "#",
    },
    {
      title: "Smart Dustbin",
      description: "An IoT-based waste segregation system using moisture sensors and Arduino.",
      video: true,
      codeLink: "https://github.com/kdgohil01/smart-dustbin",
    },
    {
      title: "Crypto-Stego Lab",
      description: "Explore the art of secure communication through this project that demonstrates encrypting text and embedding it seamlessly within images.",
      liveLink: "http://crypto-stego-lab.vercel.app",
      codeLink: "https://github.com/kdgohil01/crypto-stego-lab",
    },
  ];

  return (
    <section
      id="projects"
      className="py-20 bg-gray-50 px-4 text-center"
      data-aos="fade-up"
    >
      <h2
        className="text-4xl font-bold text-gray-800 mb-10"
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        Projects
      </h2>

      <div
        className="max-w-6xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3"
      >
        {projectList.map((project, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow p-6 text-left hover:shadow-lg transition"
            data-aos="flip-up"
            data-aos-delay={index * 100}
          >
            <h3 className="text-2xl font-semibold text-blue-600">{project.title}</h3>
            <p className="mt-2 text-gray-700">{project.description}</p>

            <div className="mt-4 space-x-3">
              {project.video ? (
                <button
                  onClick={() => setShowModal(true)}
                  className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                >
                  Live Demo
                </button>
              ) : (
                <a
                  href={project.liveLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                >
                  Live Demo
                </a>
              )}

              <a
                href={project.codeLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-4 py-2 bg-gray-200 text-blue-600 rounded hover:bg-gray-300 transition"
              >
                GitHub
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Popup for Smart Dustbin Video */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-4 w-11/12 md:w-2/3 lg:w-1/2 shadow-lg relative">
            <h4 className="text-xl font-semibold mb-2 text-center">Smart Dustbin Demo</h4>
            <video controls className="w-full rounded-lg">
              <source src="/smart-dustbin-demo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-xl text-gray-500 hover:text-red-500"
            >
              ✖
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Projects;
